import {Grid, VStack} from 'platform/foundation';
import styled from 'styled-components';

import {PROBE_ROW_COUNTS} from '../constants/probeRowCounts';
import {VehicleMotMeasurementSetters} from '../types/VehicleMotMeasurementSetters';
import {VehicleWarehouseAdaptiveMotProps} from '../types/VehicleWarehouseAdaptiveMotProps';
import {MeasuredProbe} from './MeasuredProbe';
import {VehicleMotSectionProbe} from './VehicleMotSectionProbe';

interface VehicleWarehouseMotProbesProps extends VehicleWarehouseAdaptiveMotProps {
  rowLayoutKey: string;
  setters: VehicleMotMeasurementSetters;
}

export function VehicleWarehouseMotProbes(props: VehicleWarehouseMotProbesProps) {
  return (
    <StyledProbeOuter inert aria-hidden>
      <MeasuredProbe
        kind="aggregate"
        resetKey={props.rowLayoutKey}
        onHeight={props.setters.setAggregateMeasurement}
      >
        {props.renderAggregate(true)}
      </MeasuredProbe>
      <MeasuredProbe
        kind="stacked-gap"
        resetKey={props.rowLayoutKey}
        onHeight={props.setters.setStackedGapMeasurement}
      >
        <VStack spacing={4}>
          <span />
          <span />
        </VStack>
      </MeasuredProbe>
      <Grid
        columns={props.size === 'wide' ? 2 : 1}
        horizontalSpacing={4}
        verticalSpacing={0}
        align="flex-start"
      >
        {PROBE_ROW_COUNTS.flatMap((rowCount) => [
          <VehicleMotSectionProbe
            key={`expired-${rowCount}`}
            category="expired"
            rowCount={rowCount}
            count={props.expiredCount}
            rows={props.expiredRows}
            resetKey={props.rowLayoutKey}
            renderSection={props.renderSection}
            setMeasurements={props.setters.setExpiredMeasurements}
          />,
          <VehicleMotSectionProbe
            key={`expiring-${rowCount}`}
            category="expiring"
            rowCount={rowCount}
            count={props.expiringCount}
            rows={props.expiringRows}
            resetKey={props.rowLayoutKey}
            renderSection={props.renderSection}
            setMeasurements={props.setters.setExpiringMeasurements}
          />,
        ])}
      </Grid>
    </StyledProbeOuter>
  );
}

const StyledProbeOuter = styled.div`
  position: absolute;
  inset: 0;
  height: 0;
  contain: size;
  overflow: clip;
  visibility: hidden;
  pointer-events: none;
`;
